var Carous = function(options){
	this.options = options;
	
	this.container = $(options.main_elem);
	this.bigBox = this.container.find(options.large_elem);
	this.smallBox = this.container.find(options.small_elem);

	this.length = this.smallBox.find('ul li').length;
	this.index = 0;
	
	this.init();
};

Carous.prototype.init=function(){
	var _this= this;
	$(this.options.left_btn).on('click',function(){
		_this.prev();
	});
	$(this.options.right_btn).on('click',function(){
		_this.next();
	});
	
	this.smallBox.find('ul li').on('click',function(){
		var index = $(this).index();
		_this.move(index);
	});
	
	this.move(this.index);
};

Carous.prototype.next=function(){
	if(this.index == this.length-1)
		this.move(0);
	else
		this.move(this.index+1);
};
Carous.prototype.prev=function(){
	if(this.index == 0)
		this.move(this.length-1);
	else
		this.move(this.index-1);
};

Carous.prototype.move=function(index){
	this.smallBox.find('ul li').removeClass('on');
	this.smallBox.find('ul li:eq('+index+')').addClass('on');
	
	this.bigBox.find('ul li ').css({
		'display':'none',
	});
	this.bigBox.find('ul li:eq('+index+')').css({
		'display':'flex',
	});
	
	this.index = index;
};
